import { HeaderSkeleton } from "@/components/states";
import { Loader2 } from "lucide-react";

export function PageLoader() {
  return (
    <div className="h-full w-full flex flex-col bg-zinc-50 overflow-hidden animate-fadeIn">
      <HeaderSkeleton />
      <div className="p-6 flex-1 flex flex-col items-center justify-center">
        <div className="bg-white p-8 rounded-2xl border border-zinc-200 shadow-sm text-center max-w-sm w-full space-y-4">
          <div className="w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mx-auto">
            <Loader2 className="w-6 h-6 animate-spin" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-zinc-900">Cargando Módulo</h3>
            <p className="text-xs text-zinc-500 mt-1">Sincronizando datos y componentes...</p>
          </div>
          <div className="w-full bg-zinc-100 h-1.5 rounded-full overflow-hidden">
            <div className="bg-blue-600 h-full w-2/3 animate-pulse rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
